import { ProviderCard } from '@/features/settings/components/ProviderCard';
import { StatusPill } from '@/features/settings/components/StatusPill';

interface ComingSoonProviderCardProps {
  name: string;
  /** Provider icon — typically a Phosphor logo or inline brand SVG. */
  icon: React.ReactNode;
  /** One-line explanation of what this provider will do once shipped. */
  description: string;
}

/**
 * Muted placeholder card for integration providers that aren't built yet.
 * Uses the shared ProviderCard shell with a dashed/dimmed treatment so the
 * page rhythm stays consistent with real connection cards.
 */
export function ComingSoonProviderCard({ name, icon, description }: ComingSoonProviderCardProps) {
  return (
    <ProviderCard
      muted
      icon={icon}
      name={name}
      description={description}
      actions={
        <StatusPill tone="muted" dot={false}>
          Coming soon
        </StatusPill>
      }
    />
  );
}
